
function init() {
  const ROOT = document.getElementById("ss-aichat");
  const toggle = document.getElementById("ss-aichat-toggle");
  const panel = document.getElementById("ss-aichat-panel");
  const closeBtn = document.getElementById("ss-aichat-close");
  const form = document.getElementById("ss-aichat-form");
  const input = document.getElementById("ss-aichat-input");
  const msgArea = document.getElementById("ss-aichat-messages");
  if (!ROOT || !toggle || !panel || !closeBtn || !form || !input || !msgArea) return;
  const ENDPOINT = ROOT.dataset.endpoint || "https://starshield-chat-proxy.azurewebsites.net/api/chat";
  const SESSION_KEY = "ss_aichat_session_id";
  let sessionId = sessionStorage.getItem(SESSION_KEY) || null;
  let isOpen = false;
  let busy = false;
  toggle.addEventListener("click", () => isOpen ? closeChat() : openChat());
  closeBtn.addEventListener("click", closeChat);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && isOpen) closeChat();
  });
  function openChat() {
    isOpen = true;
    ROOT.classList.add("ss-aichat--open");
    panel.classList.add("ss-aichat__panel--open");
    toggle.setAttribute("aria-expanded", "true");
    panel.setAttribute("aria-hidden", "false");
    input.focus();
  }
  function closeChat() {
    isOpen = false;
    ROOT.classList.remove("ss-aichat--open");
    panel.classList.remove("ss-aichat__panel--open");
    toggle.setAttribute("aria-expanded", "false");
    panel.setAttribute("aria-hidden", "true");
  }
  function addMessage(role, text, { escalated = false } = {}) {
    const wrap = document.createElement("div");
    wrap.className = `ss-aichat__msg ss-aichat__msg--${role === "user" ? "user" : "ai"}`;
    if (escalated) wrap.classList.add("ss-aichat__msg--escalated");
    const p = document.createElement("p");
    p.textContent = text;
    wrap.appendChild(p);
    if (escalated) {
      const tag = document.createElement("span");
      tag.className = "ss-aichat__escalated-tag";
      tag.textContent = "You've been connected with our support team";
      wrap.appendChild(tag);
    }
    msgArea.appendChild(wrap);
    msgArea.scrollTop = msgArea.scrollHeight;
    return wrap;
  }
  function addError(text) {
    const wrap = document.createElement("div");
    wrap.className = "ss-aichat__msg ss-aichat__msg--ai ss-aichat__msg--error";
    const p = document.createElement("p");
    p.textContent = text;
    wrap.appendChild(p);
    msgArea.appendChild(wrap);
    msgArea.scrollTop = msgArea.scrollHeight;
  }
  function showTyping() {
    const wrap = document.createElement("div");
    wrap.className = "ss-aichat__msg ss-aichat__msg--typing";
    for (let i = 0; i < 3; i++) wrap.appendChild(document.createElement("span"));
    msgArea.appendChild(wrap);
    msgArea.scrollTop = msgArea.scrollHeight;
    return wrap;
  }
  function setUI(disabled) {
    busy = disabled;
    input.disabled = disabled;
    form.querySelector(".ss-aichat__send").disabled = disabled;
  }
  async function send(text) {
    if (busy || !text.trim()) return;
    setUI(true);
    addMessage("user", text);
    const typing = showTyping();
    try {
      const body = { message: text };
      if (sessionId) body.sessionId = sessionId;
      const res = await fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
      const data = await res.json();
      if (!data || !data.reply) throw new Error("Empty response");
      if (data.sessionId) {
        sessionId = data.sessionId;
        sessionStorage.setItem(SESSION_KEY, sessionId);
      }
      typing.remove();
      addMessage("assistant", data.reply, { escalated: !!data.escalated });
    } catch (err) {
      console.error("[AI Chat]", err);
      typing.remove();
      addError(err.message || "Something went wrong. Please try again.");
    } finally {
      setUI(false);
      input.focus();
    }
  }
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const text = input.value.trim();
    if (!text) return;
    input.value = "";
    send(text);
  });
}
document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", init) : init();
